import { IsProd } from "@/constants/config";
import { getTodayString } from "@/utils/index";
import request from "@/utils/request";

const PATH_PREFIX = IsProd ? "/v1/" : "/vb/";

export const recordRoutes = (data: { query: string; type: string }) => {
  return request.post(PATH_PREFIX + "record_routes", {
    ...data,
  });
};

export const recordFlights = (data: { query: string; type: string }) => {
  return request.post(PATH_PREFIX + "record_flights", {
    ...data,
  });
};

export const recordMega = (data: { query: string; type: string }) => {
  const todayStr = getTodayString();
  return request.post(PATH_PREFIX + "record_mega", {
    ...data,
    date: todayStr,
  });
};

export const recordRefresh = (data: { query: string; type: string }) => {
  const todayStr = getTodayString();
  return request.post(PATH_PREFIX + "record_refresh", {
    ...data,
    date: todayStr,
  });
};

export const getMegaUsage = () => {
  const todayStr = getTodayString();
  return request.post(PATH_PREFIX + "user_api_usage", {
    api_name: "record_mega",
    date: todayStr,
  });
};

export const recordDeals = (data: { query: string; type: string }) => {
  return request.post(PATH_PREFIX + "record_deals", {
    ...data,
  });
};

export const recordFirstClass = (data: { query: string; type: string }) => {
  return request.post(PATH_PREFIX + "record_first_class", {
    ...data,
  });
};
